import LandingNav from './LandingNav';
export default LandingNav;
